import { useApprovalDrawerViewOptimizationFlag } from '@/hooks/feature_flag/useApprovalDrawerViewOptimizationFlag';
import { useState } from 'react';

export const JournalLayouts = {
  table: 'table',
  card: 'card',
} as const;

export type JournalLayout =
  (typeof JournalLayouts)[keyof typeof JournalLayouts];

const DEFAULT_LAYOUT: JournalLayout = JournalLayouts.table;

/**
 * Tracks the 仕訳 layout choice for the current drawer session only.
 * Mirrors `useTransactionsLayout` (NA-5528): table is always the layout when
 * the drawer opens — the choice is not persisted across drawer opens or users.
 *
 * Gated by the same `approval-drawer-view-optimization` flag as the
 * Transactions section — this is one flag covering the whole "approval
 * drawer view optimization" initiative, not a per-section flag. The clamp
 * lives here rather than at the call site so a caller cannot forget it: with
 * the flag off the layout is always `table`, even if the user switched to
 * `card` earlier in the same session while the flag was on.
 */
export const useJournalLayout = () => {
  const isLayoutSwitchEnabled = useApprovalDrawerViewOptimizationFlag();

  const [layout, setLayout] = useState<JournalLayout>(DEFAULT_LAYOUT);

  return {
    layout: isLayoutSwitchEnabled ? layout : DEFAULT_LAYOUT,
    setLayout,
    isLayoutSwitchEnabled,
  };
};
